import type { RouteRecordRaw } from "vue-router"

const ProveRoutes: RouteRecordRaw[] = [
  {
    name: "workflow.prove",
    path: "prove",
    children: [
      {
        name: "workflow.prove.intro",
        path: "",
        component: () => import("./ProveIntroView.vue"),
      },
      {
        name: "workflow.prove.instant-link",
        path: "instant-link",
        component: () => import("./ProveInstantLinkView.vue"),
      },
      {
        name: "workflow.prove.verifying",
        path: "verifying",
        component: () => import("./ProveVerificationProgressView.vue"),
      },
      {
        name: "workflow.prove.verified",
        path: "verified",
        component: () => import("./ProveVerifiedView.vue"),
        meta: {
          preventBack: true,
        },
      },
      {
        name: "workflow.prove.edit-information",
        path: "prove-edit-information",
        component: () => import("./ProveEditInformationView.vue"),
      },
    ],
  },
]

export default ProveRoutes
